import { atom } from "recoil";

export const openPriceModalState = atom({
  key: "openPriceModalState",
  default: false,
});
